import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const PrivacyPolicyPage = () => {
  return (
    <>
      <Header />
      <div className="container mx-auto p-4 text-black text-lg" style={{ backgroundColor: '#E9A969' }}>
        <h1 className="text-2xl font-bold">Privacy Policy</h1>
        
        <h1>Privacy Policy</h1>
  <p><strong>Effective Date:</strong> 15/07/2025</p>

  <p>This Privacy Policy explains how <strong>Cosmelytix</strong> ("we", "us", or "our") collects, uses, and protects your personal information when you use our web app.</p>

  <p>By using Cosmelytix, you agree to the practices outlined in this policy.</p>

  <h2>1. Information We Collect</h2>

  <h3>a. Information You Provide via Third-Party Login</h3>
  <p>When you log in using <strong>Facebook</strong> or <strong>Google</strong>, we may receive:</p>
  <ul>
    <li>Your name</li>
    <li>Email address</li>
    <li>Profile picture (optional)</li>
    <li>Public profile information as authorized by your settings</li>
  </ul>
  <p>We do <strong>not</strong> store your third-party login credentials.</p>

  <h3>b. Usage Data</h3>
  <p>We may collect data about your interaction with our platform, such as:</p>
  <ul>
    <li>Pages visited</li>
    <li>Features used</li>
    <li>Services viewed</li>
    <li>Time and duration of visits</li>
  </ul>
  <p>This helps us improve user experience and service offerings.</p>

  <h2>2. How We Use Your Information</h2>
  <p>We use the information we collect to:</p>
  <ul>
    <li>Provide and maintain the Service</li>
    <li>Personalize your experience</li>
    <li>Communicate important updates</li>
    <li>Analyze usage trends</li>
    <li>Improve functionality and offerings</li>
  </ul>
  <p>We do <strong>not</strong> sell or rent your personal information to third parties.</p>

  <h2>3. Cookies and Tracking Technologies</h2>
  <p>Cosmelytix may use cookies and similar technologies to:</p>
  <ul>
    <li>Maintain your login session</li>
    <li>Track user behavior anonymously</li>
    <li>Improve site performance</li>
  </ul>
  <p>You can control cookie settings through your browser.</p>

  <h2>4. Data Sharing and Disclosure</h2>
  <p>We only share your data in the following cases:</p>
  <ul>
    <li><strong>With service providers</strong> that help us operate Cosmelytix (e.g., cloud hosting)</li>
    <li><strong>To comply with legal obligations</strong>, such as law enforcement requests</li>
    <li><strong>In the event of a business transfer</strong>, such as a merger or acquisition</li>
  </ul>

  <h2>5. Data Security</h2>
  <p>We take reasonable steps to protect your data from unauthorized access, use, or disclosure. However, no system is 100% secure.</p>

  <h2>6. Your Rights and Choices</h2>
  <p>You have the right to:</p>
  <ul>
    <li>Request access to your data</li>
    <li>Request correction or deletion of your data</li>
    <li>Withdraw consent (e.g., disconnect third-party login)</li>
    {/* <li>Contact us regarding privacy concerns at <a href="mailto:[Insert Contact Email]">[Insert Contact Email]</a></li> */}
  </ul>

  <h2>7. Third-Party Links</h2>
  <p>Cosmelytix may include links to external websites. We are not responsible for their privacy practices.</p>

  <h2>8. Children’s Privacy</h2>
  <p>Our Service is not intended for users under the age of 13 (or equivalent digital age in your region). We do not knowingly collect personal data from children.</p>

  <h2>9. International Users</h2>
  <p>If you access Cosmelytix from outside the UK or USA, your information may be transferred to and processed in our servers located in the UK or USA.</p>

  <h2>10. Changes to This Policy</h2>
  <p>We may update this Privacy Policy from time to time. We will notify you via the app or email if significant changes are made. Continued use of the Service constitutes acceptance of the updated policy.</p>

  <h2>11. Contact Us</h2>
  <p>If you have any questions or concerns about this Privacy Policy, contact us at:<br />
  <a href="mailto:[info@cosmelytix.com]" style={{'color': '#5F40A1'}}>info@cosmelytix.com</a><br />
            <a href="https://cosmelytix.com/" className="text-[#5F40A1]">cosmelytix.com</a>
   </p>

      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
